import { render, staticRenderFns } from "./table.component.vue?vue&type=template&id=3738c340&scoped=true"
import script from "./table.component.vue?vue&type=script&lang=ts"
export * from "./table.component.vue?vue&type=script&lang=ts"
import style0 from "./table.component.vue?vue&type=style&index=0&id=3738c340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738c340",
  null
  
)

export default component.exports